<template>
<div class='reset-password login-form'>
  <h1>{{$t('actions.resetPassword.title')}}</h1>
  <el-form ref="form" :model='form' :rules="rules">
    <el-form-item prop="newPassword" :error="errors.first('newPassword')">
      <el-input name='password' type='password' v-model="form.newPassword" :placeholder="$t('placeholder.user.newPassword')">
      </el-input>
    </el-form-item>

    <el-form-item prop="passwordConfirmation" :error="errors.first('passwordConfirmation')">
      <el-input type='password' v-model='form.passwordConfirmation' :placeholder="$t('placeholder.user.passwordConfirmation')" />
    </el-form-item>

    <el-form-item>
      <el-button @click="reset" type="primary submit-btn">{{$t('actions.resetPassword.submit')}}</el-button>
      <span class="el-form-item__error">{{errors.first('custom')}}</span>
    </el-form-item>
  </el-form>
</div>
</template>

<script>
import Validator from '@/mixins/validator'

export default {
  data() {
    return {
      form: {
        newPassword: null,
        passwordConfirmation: null
      }
    }
  },
  mixins: [Validator],
  rules: {
    confirmed: { target: 'passwordConfirmation', original: 'newPassword', recursion: 'form' },
    required: 'newPassword'
  },
  methods: {
    reset() {
      let vm = this

      // 前端验证
      let p1 = new Promise((resolve, reject) => {
        this.$refs['form'].validate(res => {
          res ? resolve() : reject('form')
        })
      })

      p1.then(_ => {
        vm.$store.dispatch('user/resetPassword', {
          reset_password_token: vm.$route.query.token,
          password: vm.form.newPassword
        }).then(_ => {
          vm.$router.push({
            path: '/'
          })
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// reset_password.view.vue?1c522ce7